import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const SingleRowDesignSettings = {
  //  Dimension
  'data-list-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },

  // Alignment
  'data-list-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'data-list-design-headline-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'data-list-design-title-alignment': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
  'data-list-design-content-alignment': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },

  // Spacing
  'data-list-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'data-list-design-padding': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'data-list-design-headline-margin': {
    phone: getDefaultMargin([20, 5]),
    'phone-landscape': getDefaultMargin([20, 5]),
    tablet: getDefaultMargin([20, 5]),
    'tablet-landscape': getDefaultMargin([20, 5]),
    desktop: getDefaultMargin([20, 5]),
    tv: getDefaultMargin([20, 5]),
  },

  // (nested) typography
  'data-list-design-typography': {
    'data-list-design-title-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
    },
    'data-list-design-content-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
}
